export default __webpack_public_path__ + "static/media/ingenieria.aefae4da.png";